/*
 * @Author: Json Chen
 * @Date: 2021-06-23 09:35:12
 * @LastEditTime: 2021-07-13 13:09:58
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/LinkLibrary/Components/LinkItems.tsx
 */
import React from 'react';
import { Dropdown, Menu } from 'antd';
import { useRequest } from 'ahooks';
import {
  getLinkedItems,
  linkItemUnLink,
} from '@/src/request/settings/linkLibrary';
import { Button, SizeFittingTable } from '@/src/components/Antd';
import Warning from '@/src/components/Antd/Modal/WarningModal';

import { BulkEditor } from '@/src/components';
import styles from '../style.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
interface IProps {
  uuid: string;
}

const RenderLinkItems = ({ uuid }: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const [selectedItems, setSelectItems] = React.useState([]);
  const [visible, setVisible] = React.useState(false);
  const [_unLinkIds, _setUnLinkIds] = React.useState<string[]>([]);
  const [list, setList] = React.useState([]);

  const { loading: getLinkItemsLoading, run: _getLinkedItems } = useRequest(
    (uuid) => {
      return getLinkedItems(uuid);
      // return getLinkedItems('5283a441-007e-4728-bbaf-17db5cd1ce37');
    },
    {
      manual: true,
      onSuccess: (result) => {
        setList(result);
      },
    },
  );

  const { loading: linkItemUnLinkLoading, run: _linkItemUnLink } = useRequest(
    (uuids: string[]) => {
      // return getLinkedItems(uuid);
      return linkItemUnLink({
        uuids,
      });
    },
    {
      manual: true,
      onSuccess: (result) => {
        if (result) {
          _getLinkedItems(uuid);
        }
        setVisible(false);
      },
    },
  );

  const handleOnItemUnlink = (ids) => {
    setVisible(true);
    _setUnLinkIds(ids);
  };

  // 多选unlink
  const handleOnUnlinkClick = (ids: Array<string>) => {
    handleOnItemUnlink(ids);
  };

  // 单选unlink
  const handleOnMenuItemClick = (item) => {
    handleOnItemUnlink([item.uuid]);
  };

  const handleSelectChange = (selectedRowKeys) => {
    setSelectItems(selectedRowKeys.filter((s) => !!s));
  };

  const handleOnOk = () => {
    _linkItemUnLink(_unLinkIds);
    const selected = selectedItems;
    selected.splice(
      selected.find((item) => item === _unLinkIds),
      1,
    );
    setSelectItems(selected);
    setSelectItems([]);
  };
  const handleOnCancel = () => {
    setVisible(false);
  };

  const columns = [
    {
      title: getI18n('storeLinkLibrary.detail.linkedItems'),
      key: 'linkedItem',
      default: true,
      width: 259,
      childGenerate: (_, record, index) => {
        return (
          <div className={`${styles.products} ${styles.linkedItem}`}>
            {record.imageUrl && (
              <div
                className={styles.img}
                style={{ backgroundImage: `url('${record.imageUrl}')` }}
              />
            )}
            <span className={styles.name}>{record.linkedItem || ''}</span>
          </div>
        );
      },
    },
    {
      title: getI18n('storeLinkLibrary.detail.	LinkedItemType'),
      dataIndex: 'linkedItemType',
      key: 'linkedItemType',
      default: true,
      width: 180,
      childGenerate: (text: string) => {
        return <div>{text}</div>;
      },
    },
    {
      title: getI18n('storeLinkLibrary.detail.location'),
      key: 'location',
      dataIndex: 'location',
      default: true,
      width: 528,
      textWrap: 'word-break',
      childGenerate: (text: string) => {
        return <div>{text}</div>;
      },
    },
    {
      title: getI18n(
        'general.advancedFilters.commonStoreProductsWithTable.actions',
      ),
      default: true,
      optional: true,
      align: 'center',
      width: 80,
      childGenerate: (_, record, index) => {
        return (
          <Dropdown
            trigger={['click']}
            getPopupContainer={() =>
              document.getElementById(`linked-item-action-${index}`)
            }
            overlay={
              <Menu>
                <Menu.Item
                  key='0'
                  onClick={() => {
                    console.log(record);
                  }}>
                  {getI18n('storeLinkLibrary.detail.viewthisitem')}
                </Menu.Item>
                <Menu.Item
                  key='1'
                  onClick={() => {
                    handleOnMenuItemClick(record);
                  }}
                  className={styles.linkedItemBulkEditorItem}>
                  {getI18n('storeLinkLibrary.detail.unlinkthisitem')}
                </Menu.Item>
              </Menu>
            }>
            <Button
              id={`linked-item-action-${index}`}
              className={styles.linkedItemActionsDropDownButton}>
              ···
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  React.useEffect(() => {
    _getLinkedItems(uuid);
  }, []);

  return (
    <div className={styles.linkedItemContainer}>
      <div className={styles.linkedItemBulkEditor}>
        <BulkEditor
          id={`linkedItemBulkEditor`}
          bulkEditItemClassName={styles.linkedItemBulkEditorItem}
          buttonMenu={[
            {
              key: getI18n('general.unlink'),
              value: getI18n('storeLinkLibrary.detail.unlinkselecteditems'),
              function: handleOnUnlinkClick,
            },
          ]}
          selectedRowKeys={selectedItems}
          hideSelectAll
        />
        <div className={styles.linkedItemMessage}>
          Linked to {list.length} items
        </div>
      </div>
      <SizeFittingTable
        loading={linkItemUnLinkLoading || getLinkItemsLoading}
        rowKey='uuid'
        pagination={false}
        className={styles.table}
        id='LinkLibraryEdit'
        columns={columns}
        dataSource={list}
        locale={{
          emptyText: getI18n('storeLinkLibrary.detail.nolinkeditems'),
        }}
        rowSelection={{
          onChange: handleSelectChange,
        }}
      />
      <Warning
        visible={visible}
        header={getI18n('storeLinkLibrary.detail.unlinkselecteditems')}
        onOk={handleOnOk}
        okText={getI18n('general.unlink')}
        cancelText={getI18n('general.cancel')}
        onCancel={handleOnCancel}>
        {getI18n('storeLinkLibrary.detail.unlinkTip')}
      </Warning>
    </div>
  );
};

export default RenderLinkItems;
